import { privateAxios } from "../lib/api";
import { ApiConstants } from "../utils/constants";

export class ReferralsService {
    static async getReferrals() {
        const response = await privateAxios.get(ApiConstants.referralsURL);
        return response.data;
    }
}